import { render, staticRenderFns } from "./CorrespondenceEmailSummary.vue?vue&type=template&id=cf01d690"
import script from "./CorrespondenceEmailSummary.vue?vue&type=script&lang=js"
export * from "./CorrespondenceEmailSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports